import { runInAction } from 'mobx';
import { ocapiClient } from '../../../api-clients/ocapi/client';
import { wrapInArray } from '../../../utils/array-utils';
import { createFetchedData } from '../../../utils/fetched-data/create-fetched-data';
import { createFetchedDataRecord } from '../../../utils/fetched-data/create-fetched-data-record';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { logger } from '../../../utils/logger';
import { updateObject } from '../../../utils/object-utils';
import { nonEmptyStringValidator } from '../../../utils/validators/string';
import { browsingDomainStore } from '../../browsing/store';
import { seatingDomainStore } from '../store';
export const loadSeatLayoutForShowtime = async (showtimeId) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot load seat layout. Provided showtimeId is invalid.');
    }
    // The way the data is currently stored prohibits this, as do not know the `seatLayout.id` until after the showtime has been loaded.
    const { seatLayout, relatedData } = await ocapiClient.instance.v1.seating.masterData.seatLayout.getForShowtime(showtimeId);
    const { areaCategories, screen } = relatedData;
    const cacheDuration = getCacheDuration('seatingMasterData');
    runInAction(() => {
        seatingDomainStore.data.seatLayouts[seatLayout.id] = createFetchedData(seatLayout, cacheDuration);
        updateObject(seatingDomainStore.data.areaCategories, createFetchedDataRecord(areaCategories, 'id', cacheDuration));
        updateObject(browsingDomainStore.data.screensById, createFetchedDataRecord(wrapInArray(screen), 'id', cacheDuration));
    });
    return seatLayout;
};
